import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ApiConfiguration } from 'src/app/services/http/api-configuration';
import { ApiService } from 'src/app/services/http/api.service';
import { ToastClientService } from 'src/app/services/toast/toast-client.service';
import {NgbModal, ModalDismissReasons} from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-view-enrollment',
  templateUrl: './view-enrollment.component.html',
  styleUrls: ['./view-enrollment.component.scss']
})
export class ViewEnrollmentComponent implements OnInit {

  closeResult: string;


  constructor(private active:ActivatedRoute, 
    private service: ApiService, 
    private router: Router,
    private config: ApiConfiguration,
    private modalService: NgbModal,
    private toast: ToastClientService) { }
  public id;
  public enrollData;
  ngOnInit() {   
    this.active.queryParams.subscribe((res:any)=>{
      this.id = res.enrollId;
      this.service.get(this.config.getVisitEnrollment+'&id='+this.id)
      .subscribe((res:any)=>{
        this.enrollData = res.data.pending_enrollments[0];
        console.log(this.enrollData)
      })
    })
    
  }


  approve(id){
    let payload = {
      program_id: 1,
      id: this.id,
      approve_reject: 1

    }
    this.service.postWithFormData(this.config.approveRejectEnroll, payload)
    .subscribe((res:any)=>{
      if(res.status == 200){
        this.toast.Success("Approved");
        this.ngOnInit()
        this.router.navigateByUrl('/hubAdmin/get-enrollments');
      }else{
        console.log(res)
      }
    })
  }

  reject(){
    let payload = {
      program_id: 1,
      id: this.id,
      approve_reject: 0

    }
    this.service.postWithFormData(this.config.approveRejectEnroll, payload)
    .subscribe((res:any)=>{
      if(res.status == 200){
        this.toast.Error("Rejected");
        this.ngOnInit()
        this.router.navigateByUrl('/hubAdmin/get-enrollments');

      }else{
        console.log(res)
      }
    })

  }

  open(content) {
    this.modalService.open(content, {ariaLabelledBy: 'modal-basic-title'}).result.then((result) => {
      this.closeResult = `Closed with: ${result}`;
    }, (reason) => {
      this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
    });
  }

  private getDismissReason(reason: any): string {
    if (reason === ModalDismissReasons.ESC) {
      return 'by pressing ESC';
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return 'by clicking on a backdrop';
    } else {
      return  `with: ${reason}`;
    }
  }



}
